import React from 'react';
import { connect } from 'react-redux';
import { Pagination, PaginationItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import config from '../../config';

import './PaginationWidget.scss';

const PaginationWidget = (props) => {
  const { i18n, total, activePage, linkPath, itemsPerPage = config.itemsPerPage } = props;
  const constructURLLink = (label = '', page) => {
    const { translations = {}, locale } = i18n || {};
    const t = translations[locale] || {};
    const innerSpan = [];
    let btnClass = '';
    if (label !== '') {
      btnClass = ' page-link-btn';
      innerSpan.push(
        <span aria-hidden="true" key={page + label}>
          {t.pagination[label]}
        </span>,
      );
      innerSpan.push(
        <span className="sr-only" key={`l${page}${label}`}>
          {label}
        </span>,
      );
    } else {
      btnClass = '';
      innerSpan.push(page);
    }
    return (
      <Link to={`${linkPath}/${page}`} className={`page-link${btnClass}`} aria-label={label}>
        {innerSpan}
      </Link>
    );
  };

  const maxPage = Math.ceil(total / itemsPerPage);

  const pNumbersEle = () => {
    const limitPage = config.paginatioinLimitPerPage;

    let page = activePage || 1;
    let total_page = maxPage || 1;

    page = parseInt(page, 10);
    total_page = parseInt(total_page, 10);
    if (page > total_page) {
      page = total_page;
    }

    let start_page = page * 1 - limitPage / 2;
    if (start_page < 1) {
      start_page = 1;
    }

    let end_page = start_page + (limitPage - 1);

    if (end_page > total_page) {
      const end_exceed = end_page - total_page;
      end_page = total_page;
      start_page -= end_exceed;
      if (start_page < 1) {
        start_page = 1;
      }
    }

    const pageElems = [];
    for (let i = start_page; i <= end_page; i++) {
      pageElems.push(
        <PaginationItem {...(i === page && { active: true })} key={i}>
          {constructURLLink('', i)}
        </PaginationItem>,
      );
    }

    return pageElems;
  };

  const pPrevEle = () => {
    const pPrev = [];
    if (parseInt(activePage, 10) !== 1) {
      pPrev.push(<PaginationItem key="Prev">{constructURLLink('Prev', '1')}</PaginationItem>);
    }
    return pPrev;
  };

  const pNextEle = () => {
    const pNext = [];
    if (parseInt(activePage, 10) !== maxPage) {
      pNext.push(
        <PaginationItem key="Next">
          {constructURLLink('Next', parseInt(activePage, 10) + 1)}
        </PaginationItem>,
      );
    }
    return pNext;
  };

  return (
    <Pagination aria-label="Page navigation">
      {pPrevEle()}
      {pNumbersEle()}
      {pNextEle()}
    </Pagination>
  );
};

const mapStateToProps = (state) => ({
  i18n: state.i18n,
});

const connectStore = connect(mapStateToProps, null, null, {
  pure: true,
})(PaginationWidget);

export { PaginationWidget as PaginationWidgetComponent }; // <- For component Unit Test
export default connectStore;
